<template>
  <div v-if="debugging">
    <div v-if="hidden" @click="hidden = !hidden" style="color: orange"><icon-default icon="info" style="cursor: pointer"></icon-default></div>
    <pre v-else @click="hidden = !hidden">
       {{infoString}}
    </pre>
  </div>
</template>

<script>
import LocalStorage from "../../services/localStorage";

export default {
  name: "AppDebugging",
  props: {
    info: {
      required: true,
    },
  },
  data() {
    return {
      hidden: true
    }
  },
  computed: {
    debugging() {
      return LocalStorage.getDebuggingMode() || false;
    },
    infoString() {
      if (typeof this.info === 'string') {
        return this.info;
      }

      if (typeof this.info === 'object') {
        return JSON.stringify(this.info);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

</style>
